import debounce from 'debounce-async';
import { useMemo, useState } from 'react';
import axios from 'axios';
import { publisher_autosuggest } from '../../api/api';
import AsyncSelect from 'react-select/async';

const FilterOrdersPublisher = ({ pullback, defaultValue }) => {

    const [value, setValue] = useState({ value: defaultValue, label: defaultValue });

    const loadOption = useMemo(() => {
        return debounce(async (inputValue) => {
            const { data } = await axios.get(publisher_autosuggest(inputValue))

            const options = data.map((account) => ({
                value: account.userId,
                label: `${account.firstName} (${account.lastName})`,
            }));

            return options;
        }, 300);
    }, []);



    const handleChangeAutoSuggest = (selectedOption) => {
        pullback(selectedOption.value)
        setValue(selectedOption)
    }



    return (
        <div className='flexRow'>
            <AsyncSelect
                cacheOptions
                placeholder='ناشر'
                value={value.value ? value : null}
                loadOptions={loadOption}
                onChange={handleChangeAutoSuggest}
                noOptionsMessage={() => 'ناشری یافت نشد!'}
                loadingMessage={() => 'لطفا صبر کنید...'}
                isRtl
                required={true}
            />
        </div>
    );
}

export default FilterOrdersPublisher;